module.exports = __webpack_public_path__ + "static/media/dejected-depressed-resting-svgrepo-com.28219931.svg";